export default "__VITE_ASSET__dg7JCeBd__"